import styled from 'styled-components'

const QuestionMarks = styled.span`
	color: ${props => props.theme.textVeryLight};
`

export default QuestionMarks
